import { feature as recaptchaServiceFeature } from '@central-products/recaptcha-service';

export const recaptchaServicePlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    addBootstrapperFeature(recaptchaServiceFeature, {
      siteKey: params.siteKey,
    });
  },
};
